import React from 'react'
import { reduxForm, Field } from 'redux-form'
import Card from '../Shared/Card'
import Button from '../Shared/Button'
import MultipleChoice from '../Shared/Forms/MultipleChoice'

const FORM_NAME = 'profileSetupForm'

const ROLE_OPTIONS = [
  { label: 'Engineering', value: 'engineering' },
  { label: 'Customer Experience', value: 'cx' },
  { label: 'Product', value: 'product' },
  { label: 'Operations', value: 'operations' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Sales', value: 'sales' },
  { label: 'Founder / Executive', value: 'founder/exec' },
]

const STACK_OPTIONS = [
  { label: 'Ruby on Rails', value: 'ruby/rails' },
  { label: 'Node / Express', value: 'node/express' },
  { label: 'Python / Django', value: 'python/django' },
  { label: 'PHP / Laraval', value: 'php/laraval' },
  { label: 'No-code backend', value: 'no-code' },
]

const SIZE_OPTIONS = [
  { label: 'Just Me!', value: '1' },
  { label: '2 – 10 people', value: '2-10' },
  { label: '11 – 20 people', value: '11-20' },
  { label: '21 – 50 people', value: '21-50' },
  { label: '51 – 200 people', value: '51-200' },
  { label: 'More than 200', value: '>200' },
]

const validate = values => {
  const errors = {}

  if (!values.role) {
    errors.role = 'Please select your company role'
  } else if (typeof values.role === 'object' && !values.role.other) {
    errors.role = 'Please describe your role'
  }

  if (!values.stack) {
    errors.stack = 'Please select your tech stack'
  } else if (typeof values.stack === 'object' && !values.stack.other) {
    errors.stack = 'Please describe your backend tech stack'
  }

  if (!values.companySize) {
    errors.companySize = 'Please select your company size'
  }

  return errors
}

const Form = function ProfileSetupForm({ submitting, handleSubmit, error }) {
  return (
    <Card
      component="form"
      onSubmit={handleSubmit}
      actions={<Button loading={submitting}>Continue</Button>}
    >
      <h1>Let’s get to know each other.</h1>
      <p className="subtitle">
        Tell us a little more about you & your software, so we can optimize your
        experience.
      </p>
      <Field
        component={MultipleChoice}
        name="companySize"
        label="How big is your company?"
        options={SIZE_OPTIONS}
      />
      <Field
        component={MultipleChoice}
        allowOther
        name="role"
        label="What’s your role?"
        options={ROLE_OPTIONS}
      />
      <Field
        component={MultipleChoice}
        allowOther
        name="stack"
        label="What’s your primary backend stack?"
        options={STACK_OPTIONS}
      />
    </Card>
  )
}

export default reduxForm({
  form: FORM_NAME,
  validate,
})(Form)
